import React from "react";
import PropTypes from "prop-types";

const FormSuccessMessage = (props) => (
  <div className="alert alert-success">
    <ul>
      <li>{props.successMessage}</li>
    </ul>
  </div>
);

FormSuccessMessage.propTypes = {
  successMessage: PropTypes.string,
};

export default FormSuccessMessage;



// WEBPACK FOOTER //
// ./src/components/forms/FormSuccessMessage.js